import React from "react";
import {AButton, AEmptyState, AIcon, APanel} from "@cisco-sbg-ui/magna-react";
import classNames from "classnames";
import {appConfig} from "config/defaultConfig";
import {t} from "i18next";
import {Link} from "react-router-dom";
import css from "./InvestigationNotFound.module.scss";

const {ROUTES} = appConfig.APP;

const InvestigationNotFound = () => (
  <APanel className={classNames(css.panel, "mx-0")}>
    <div
      className={css.investigationNotFound}
      data-testid={"InvestigationNotFound-Container"}>
      <AEmptyState variant="positive" large />
      <h2 className="mb-4">{t("investigationDetail.messages.noData")}</h2>
      <p className="mb-10">
        {t("investigationDetail.messages.mayHaveBeenDeleted")}
      </p>
      <AButton tertiary medium component={Link} to={ROUTES.INVESTIGATE}>
        <AIcon left size="small">
          arrow-left
        </AIcon>
        <span>{t("investigationDetail.messages.returnToInvestigatePage")}</span>
      </AButton>
    </div>
  </APanel>
);

export default InvestigationNotFound;
